export default function IconContainer({ children }) {
  return (
    <div className="pt-8 sm:pt-0 flex justify-center px-12 md:px-0 h-3/4 md:h-auto">
      {children}
    </div>
  );
}
